import { adminRoleFragment } from '~/graphql/documents/core';
import { useFragment } from '~/graphql/generated/fragment-masking';
import { RoleContextType } from '~/graphql/generated/graphql';

/**
 * Mirrors @requiresDevMode: allowed environments only, global admins off-local, and the flag on.
 * The server also enforces admin MFA. Local developers can use the tools from student accounts.
 */
export const useDevModeGate = async (): Promise<boolean> => {
  const { $featureFlagsProvider } = useNuxtApp();
  const config = useRuntimeConfig();
  const { user } = useAuthStore();

  const environment = config.public.env;
  const allowedEnvironments = ['local', 'testing', 'dev', 'development', 'staging-au', 'staging-us'];

  if (!allowedEnvironments.includes(environment)) {
    return false;
  }

  const isGlobalAdmin = user?.adminRoles.some(role =>
    useFragment(adminRoleFragment, role).contextType === RoleContextType.Global,
  );

  if (environment !== 'local' && !isGlobalAdmin) {
    return false;
  }

  return await $featureFlagsProvider.getFlag('dev-mode-allowed', { userId: 'anonymous' });
};
